import { API_PUBLIC_ACCOUNT_EXECUTIVES, API_PUBLIC_LANDING_LEARN_MORE } from 'config'
import Api from 'services/api'

/** Public (no JWT required) — visible account executives only. */
export const getPublicAccountExecutives = () => {
  return Api.get(API_PUBLIC_ACCOUNT_EXECUTIVES)
}

/** Public (no JWT required) — landing learn-more / FAQ items in order. */
export const getPublicLandingLearnMore = () => {
  return Api.get(API_PUBLIC_LANDING_LEARN_MORE)
}
